import React, { Component, PropTypes } from 'react';
import './RoomPickerCell.css';

class RoomPickerCell extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(ev) {
    const { room, onClick } = this.props;
    ev.preventDefault();
    onClick(room);
  }

  render() {
    const { room, name, description } = this.props;

    return (
      <div className="RoomPickerCell" onClick={this.handleClick}>
        <span className="RoomPickerCell__title">{name}</span>
        <span className="RoomPickerCell__desc">{description}</span>
      </div>
    );
  }
};

RoomPickerCell.propTypes = {
  room: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default RoomPickerCell;



// WEBPACK FOOTER //
// ./src/components/RoomPickerCell.js